/**
 * Runtime configuration for the generated notifications client (hey-api fetch).
 *
 * Import SDK functions from this module, never from connectors/notifications
 * directly: importing here guarantees the client is configured (base URL, auth
 * token, 401 handling, error normalization) before the first call. The shared
 * cross-connector wiring lives in service/connectorRuntime.
 *
 * A 401 triggers logout only when the local session token is genuinely dead —
 * see createUnauthorizedInterceptor. The SSE side degrades without logout
 * (capped backoff) in service/notificationsService.
 */
import { client } from 'connectors/notifications/client.gen';
import {
  connectorAuth,
  createUnauthorizedInterceptor,
  normalizeFastApiError,
} from 'service/connectorRuntime';
import { fetchWithRenewal } from 'service/amsFetch';

client.setConfig({
  baseUrl: process.env.NEXT_PUBLIC_NOTIFICATIONS_API_ENDPOINT || '/notifications',
  auth: connectorAuth,
  fetch: fetchWithRenewal,
});

client.interceptors.error.use(normalizeFastApiError);
client.interceptors.response.use(createUnauthorizedInterceptor('Notifications API'));

export * from 'connectors/notifications/sdk.gen';
